import { useSchoolContext } from '../context';
import { SchoolContext } from '../context/types';

/** Full SchoolContext value. Use when you need multiple fields or `reload`. */
export function useSchool(): SchoolContext {
  return useSchoolContext();
}
